import { render, staticRenderFns } from "./DeleteSkillModal.vue?vue&type=template&id=5bc05270&scoped=true&"
import script from "./DeleteSkillModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSkillModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteSkillModal.vue?vue&type=style&index=0&id=5bc05270&lang=scss&scoped=true&"
import style1 from "./DeleteSkillModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc05270",
  null
  
)

export default component.exports